/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
/* eslint-disable operator-linebreak */
/* eslint-disable arrow-parens */
import React from 'react';
import WbSunnyIcon from '@material-ui/icons/WbSunny';
import Brightness3Icon from '@material-ui/icons/Brightness3';
import { useSelector, useDispatch } from 'react-redux';

const ThemeSwitcher = props => {
  const { themeSelected } = useSelector(state => state.uiState);
  const dispatch = useDispatch();

  const toggleTheme = () => {
    const theme = localStorage.getItem('theme') === 'light' ? 'dark' : 'light';
    localStorage.setItem('theme', theme);
    if (props && props.changeLiveTheme) {
      theme === 'light'
        ? props.changeLiveTheme(true)
        : props.changeLiveTheme(false);
    }
    dispatch({ type: 'TOGGLE_THEME', payload: theme });
  };

  const allowedPaths = [
    '/alerts',
    '/reportsv2',
    '/trip-management',
    '/fleet-healthv2',
    '/driving-analysisv2',
    '/dashboard',
    '/my-fleet',
    '/reports',
    '/track-trace',
    '/owner-suite',
    '/driving-analysis',
    '/settings',
    '/fleet-health',
    '/fleet-efficiency',
    '/daily-trip-analysis',
    '/liveTrack',
    '/liveTracking',
    '/demo',
    '/support',
    '/profile',
  ];

  const currentPath = window.location.pathname;
  // eslint-disable-next-line max-len
  const isAllowed = allowedPaths.some(
    path => currentPath === path || currentPath.startsWith(`${path}/`)
  );

  return isAllowed ? (
    <span className="mr-2">
      {themeSelected === 'light' ? (
        <Brightness3Icon
          style={{ cursor: 'pointer', fill: '#fff' }}
          onClick={toggleTheme}
        />
      ) : (
        <WbSunnyIcon style={{ cursor: 'pointer' }} onClick={toggleTheme} />
      )}
    </span>
  ) : null;
};

export default ThemeSwitcher;
